import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '../constants/api-endpoints';
import { ApiResponse } from '../models/api-response.model';
import { LoginData, LoginRequest } from '../models/auth.model';
import { UserAccessModuleGrouped } from '../models/access.model';
import { SessionService } from './session.service';
import { map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../constants/app-route.constants';

export type LoginResult =
  | { kind: 'CHANGE_PASSWORD'; code: string; username: string; userId: number }
  | {
      kind: 'OK';
      code: string;
      auth: LoginData;
      accessGrouped: UserAccessModuleGrouped[];
    };

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private http: HttpClient,
    private session: SessionService,
    private router: Router,
  ) {}

  login(payload: LoginRequest) {
    return this.http
      .post<ApiResponse<any>>(API.authAdmin.login(), payload)
      .pipe(
        switchMap((r) => {
          // Caso: requiere cambio de contraseña
          if (r.code === 'LG_1003' || r.data?.requirePasswordChange) {
            sessionStorage.setItem('temp_token', r.data.tempToken);
            return of<LoginResult>({
              kind: 'CHANGE_PASSWORD',
              code: r.code,
              username: r.data?.user?.username ?? payload.username,
              userId: r.data?.user?.userId,
            });
          }

          // Caso: login normal (aquí sí hay token)
          const authData = r.data as LoginData;

          this.session.set({ auth: authData, accessGrouped: [] });

          return this.http
            .get<
              ApiResponse<UserAccessModuleGrouped[]>
            >(API.userAccess.groupedByUser(authData.user.userId))
            .pipe(
              map((res) => res.data),
              tap((accessGrouped) => {
                this.session.set({ auth: authData, accessGrouped });
              }),
              map(
                (accessGrouped): LoginResult => ({
                  kind: 'OK',
                  code: r.code,
                  auth: authData,
                  accessGrouped,
                }),
              ),
            );
        }),
      );
  }

  changeTempPassword(dto: any) {
    return this.http.post<ApiResponse<any>>(
      API.authAdmin.changeTempPassword(),
      dto,
    );
  }

  sendOtp(dto: { email: string; purpose: string; entityType: string }) {
    return this.http.post(API.otp.sendOtp(), dto);
  }

  resetPasswordWithOtp(dto: any) {
    return this.http.post(API.authAdmin.resetPassword(), dto);
  }

  logout() {
    this.session.clear();
    this.router.navigateByUrl(APP_ROUTES.AUTH.LOGIN);
  }
}
